import { Button, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";
import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ModalFixLiquidLevel } from "./modalFixLiquidLevel";
import moment from "moment";
import { tableStyles } from "src/shared/util/tableStyles";

export const FluidLevels = () => {

    const { fluidLevels } = useSelector((state) => state.location);

    const [openModal, setopenModal] = useState(false);

    const [activeFluidLevel, setActiveFluidLevel] = useState<any>(undefined)

    const onClickOpenLiquidLevel = (params:any) => {
        setActiveFluidLevel(params.row)
        setopenModal(true)
    }

    const handleOpenCloseModal = () => {
        setopenModal(!openModal)
        setActiveFluidLevel(undefined)
    }

    const paginationModel = { page: 0, pageSize: 10 };
    
    const rows: GridRowsProp = fluidLevels.map((item: any) => {
        return {
            fieldActivityId: item.fieldActivityId,
            status: item.status,
            executedDate: moment(item.executedDate).format("DD-MM-YYYY"),
            responsable: item.responsable,
            typeOfActivity: item.typeOfActivity,
            comments: item.comments,
            liquidLevel: item.liquidLevel,
            pip: item.pip,
            pwf: item.pwf,
            pumpSumergence: item.pumpSumergence,
         }
    })

    const columns: GridColDef[] = [
        {
            field: "status",
            headerName: "",
            align: "center",
            flex: 0.1,
            renderCell: (params) => {
                if (params.value === "completed") {
                    return (
                        <IconButton size="small" color="success">
                            <DoneIcon />
                        </IconButton>
                    );
                } else if (params.value === "analyzing") {
                    return (
                        <IconButton size="small" color="warning">
                            <WarningIcon />
                        </IconButton>
                    );
                } else {
                    return "";
                }
            },
        },
        {
            field: "executedDate",
            headerName: "Fecha",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "responsable",
            headerName: "Responsable",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "typeOfActivity",
            headerName: "Tipo de Actividad",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "comments",
            headerName: "Comentario",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "liquidLevel",
            headerName: "Nivel de Fluido (ft)",
            flex: 0.7,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "pip",
            headerName: "PIP (psi)",
            flex: 0.7,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "pwf",
            headerName: "PWF (psi)",
            flex: 0.7,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "pumpSumergence",
            headerName: "Sumergencia (ft)",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "actions",
            // type: "actions",
            headerName: "",
            flex: 0.5,
            width: 50,
            headerAlign: "center",
            align: "center",
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => (
                <Grid>
                    <IconButton
                        size="small"
                        onClick={() => onClickOpenLiquidLevel(params)}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Grid>
            ),
        },
    ];

    return (
        <Grid container spacing={0}>
            {activeFluidLevel && (
                <ModalFixLiquidLevel
                    open={openModal}
                    liquidLevel={activeFluidLevel}
                    onClose={handleOpenCloseModal}
                />
            )}
            <Grid size={12}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        mt: 2,
                        height: {
                            md: `calc(100vh - 395px)`,
                            lg: `calc(100vh - 395px)`,
                            xl: `calc(100vh - 400px)`,
                        },
                        ...tableStyles,
                    }}
                    getRowId={(row) => row.fieldActivityId}
                />
            </Grid>
        </Grid>
    );
};
